import React from 'react';
import Array from './Array/Array';
import styles from './Box.module.css'
const Box = () => {
    return (
        <div className={styles.Box}>
            <Array/>
        </div>
    )
}

export default Box
